<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @open="hidden" @hidden="hidden" id="modalcito">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center"><b>Cambiar el Estado/Fase del Programa</b></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center"> 
                    <!-- <p> <b>ID:</b> {{parseID()}} </p> -->
                    <p><b>Fase actual del Programa:</b> {{ getFase(prog.fase) }}</p>
                    <p><b>Programa:</b> {{ parsePro() }}</p>
                    <p class="text-primary"><b>NOTA:</b> Esta funcion se utiliza para cambiar el estado del programa, en caso de estar en PREINSCRIPCION se puede aprobar el programa.</p>
                </div>

                <p v-if="loading" class="my-0 text-center green--text"> cargando informacion... </p>

                <Alertas ref="alertar" v-bind:msgSuccess="'El cambio de fase se realizo satisfactoriamente.'" v-bind:msgLoading="'Aplicando...'" />

                <div class="modal-footer">
                    <button @click="aprobarPrograma" v-show="activo && $store.state.aprobarPrograma" :disabled="prog.fase != 0" type="button" class="btn btn-azul">Aprobar Programa</button>
                    <button @click="setfase(true)" v-show="activo && $store.state.subirFasePrograma" :disabled="prog.fase == 0" type="button" class="btn btn-azul">Subir Fase Programa</button>
                    <button @click="setfase(false)" v-show="activo && $store.state.bajarFasePrograma" :disabled="prog.fase == 0" type="button" class="btn btn-azul">Bajar Fase Programa</button>
                    <button type="button" class="btn btn-secondary" @click="hidden" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from "@/components/AAlertas.vue"; 
import { getheadersrest } from '@/components/Utils';
import axios from '@/xaxios';
import gql from "graphql-tag";
export default {
    props: {
        obj: {
            // {xid:Number,xtitle:String,xbody:String,xsql:Object}
            type: Object,
            required: true,
        },
        prog: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fase: 1,
            activo: true,
            loading: false,
        };
    },
    watch: {
        "obj.xid": function() {
            if (this.obj.xid == null) return;
            this.$refs.alertar.reset();
            this.activo = true; 
            
        },
        obj: function() {
            this.$refs.alertar.reset();
            this.activo = true; 
            window.console.log('>>>modalla');
        },
        prog: function() {
            if (this.prog == null) return;
            this.fase = this.prog.fase;
            this.$refs.alertar.reset();
            this.activo = true; 
            // this.getdataprograma(this.prog.id)
        },
    },
    components: { Alertas },
    methods: {
        hidden() {
            this.$refs.alertar.cargando();   
            this.loading = false          
        },
        parseID() {
            if (this.prog == null) return -1;
            return this.prog.id;
        },
        parsePro() {
            if (this.prog.postgrado == null) return "";
            return this.prog.postgrado.categoria.nombre + " - " + this.prog.postgrado.nombre;
        },
        getFase(fase) {
            //'inscripciones, en desarrollo, en tramite, cerrado',
            if (fase == 0) return "PREINSCRIPCION";
            else if (fase == 1) return "INSCRIPCION";
            else if (fase == 2) return "DESARROLLO";
            else if (fase == 3) return "CONCLUIDO";
            else if (fase == 4) return "ELABORACION_TRABAJOS_FINALES";
            else if (fase == 5) return "ELABORACION_DOCUMENTOS";
            else if (fase == 6) return "ARMADO_CARPETAS";
            else if (fase == 7) return "PAGO_ARANCELES";
            else if (fase == 8) return "PROCESO_TITULACION";
            else if (fase == 9) return "CERTIFICADOS_ENTREGADOS";
            else return "Desconocido: " + fase;
        },
        async getdataprograma(idprograma){
            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            if(unidad != 1) return; // solo esam
            if(this.prog.fase > 0) return;

            this.loading = true;
            this.activo = false
            const api_rest = process.env.VUE_APP_API_REST;
            let myHeaders = getheadersrest();
            let urlacademico = `${api_rest}/esam/programa/id/${idprograma}`;
            var requestOptions = { method: 'GET', headers: myHeaders, url: urlacademico };
            let res = await axios.request(requestOptions);
            this.loading = false;
            this.activo = true;
            let programa = res ? res.data : null;
            // window.console.log('prorororor', programa);
            
            const mods = programa.programa_modulo.filter(m=>!m.fecha_inicio || !m.fecha_fin)
            window.console.log('>>modulos::::', mods, this.prog.fase);
            if(mods && mods.length > 0 ){
                this.activo = false;
                setTimeout(() => {
                    window.$('#modalf').modal('toggle');
                    this.$root.$notify.show(`Hay modulos sin fechas de inicio, el cambio de fase no esta disponible`, {color:'red',x: 'right',});
                }, 200);
            }
            
        },
        submit() {},
        aprobarPrograma() {
            const univ = this.prog.universidad;
            const id_uni = univ? univ.id : null;
            let userid = this.$store.state.DATA_USER.id;
            let sedeid = this.$store.state.CARGO.sede.id
            let unidad = this.$store.state.CARGO.sede.unidad_negocio; 
            let ispaula_upi = sedeid == 121 && userid == 12988;
            const claudia_upi = 65958;
            const mariana = 160967;
            const clarise = 76447;
            

            if( unidad == 1 || id_uni == 9){
                let userid = this.$store.state.DATA_USER.id;
                // 73 marcia para esam dbs
                const is_perm = userid == 35886 || userid == 95 || ispaula_upi || userid == 59716 || userid == 73 || userid == claudia_upi || userid==30820 || userid==mariana || userid==clarise;
                if(!is_perm){
                    this.$root.$notify.show(`SOLO DNA PUEDE APROBAR EL PROGRAMA. ${sedeid}-${userid}`, {color:'red',x: 'right',});
                    return;
                }
                window.console.log('>>>>', userid);
            } else if( unidad == 15 ){ // upi 
                let userid = this.$store.state.DATA_USER.id;
                /*
                ID: 65958	5153434	Claudia	Escobar	Salguero
                ID: 76447	10384039	Clarice	Romero	Ordoñez
                */
                const is_perm = userid == 65958 || userid == 76447 || ispaula_upi || userid == 30820 || userid== 160967 || userid==mariana || userid==clarise; 
                if(!is_perm){
                    this.$root.$notify.show(`SOLO DNA PUEDE APROBAR EL PROGRAMA, ${sedeid}-${userid}`, {color:'red',x: 'right',});
                    return;
                }
                window.console.log('>>>>', userid);
            } else if(unidad == 10 && id_uni == 301){
                let userid = this.$store.state.DATA_USER.id;
                // claudia fany 65958 
                // claudia fany 30820
                const is_perm = userid == 65958 || userid == 30820 || userid == 160967 || userid==mariana || userid==clarise;
                if(!is_perm){
                    this.$root.$notify.show(`PROGRAMAS DBS, CON UPI no tienes permiso a esta accion ${sedeid}-${userid}`, {color:'red',x: 'right',});
                    return;
                }
            }

            this.obj.xsql = gql`mutation{ aprobarPrograma(input:{id:${this.prog.id},fase:${this.fase}}){ok,errors{message}} }`;
            
            var vue = this;
            vue.$refs.alertar.cargando();
            vue.activo = false;

            this.$apollo
                .mutate({
                    mutation: vue.obj.xsql,
                })
                .then((data) => {
                    window.console.log(data.data);
                    if (data.data.aprobarPrograma.ok) {
                        vue.$refs.alertar.success();
                        vue.activo = true;
                        vue.prog.fase = vue.fase + 1;
                        vue.fase = vue.prog.fase;
                        vue.$emit("exito", vue.prog.id, vue.prog.fase);
                    } else {
                        vue.activo = true;
                        var errores = JSON.stringify(data.data.aprobarPrograma.errors);
                        var obj = JSON.parse(errores);
                        var vals = "";
                        obj.forEach(function(k) {
                            vals += Object.values(k) + "-\n\t";
                        });
                        vue.$refs.alertar.invalido(vals);
                    }
                })
                .catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                });
        },
        setfase(bool_subir, continuar=false) { 
            const univ = this.prog.universidad;
            const id_uni = univ? univ.id : null;
            let userid = this.$store.state.DATA_USER.id;
            let permitido = userid == 35886 || userid == 95 || userid == 59716 || userid == 30820;
            let unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const mariana = 160967;
            const clarise = 76447;
            
            if(unidad == 10 && id_uni == 301){
                let userid = this.$store.state.DATA_USER.id;
                // claudia fany 30820
                const is_perm = userid == 65958 || userid == 30820 || userid == mariana || userid == clarise;
                if(!is_perm){
                    this.$root.$notify.show(`PROGRAMAS DBS,. CON UPI no tienes permiso a esta accion ${userid}`, {color:'red',x: 'right',});
                    return;
                }
            }
            

            if(unidad == 1 || unidad == 5){ // esam, esam latam
                if(bool_subir && this.prog.fase == 1){
                    if(!continuar && !permitido) {
                        this.mensajito();
                        return;
                    }
                }

                if(!bool_subir && this.prog.fase == 2){
                    if(!permitido) {
                        this.$root.$notify.show(`No puede bajar a la fase de inscripciones, contacte con su academico nacional`, {color:'red',x: 'right',});
                        return;
                    }
                }
            }

            let userForm = {
                programa_id: this.prog.id,
                subir: bool_subir,
            };
            window.console.log(this.prog, userForm);
            /* let a = 1;
            if(a >0) return; */

            const url = `${process.env.VUE_APP_API_REST}/api/v1/programa/fase`;
            var vue = this;
            vue.$refs.alertar.cargando();
            vue.activo = false;
            axios
                .put(url, userForm)
                .then((res) => {
                    window.console.log(res);
                    vue.$refs.alertar.success();
                    vue.activo = true;
                    if( bool_subir ){
                        vue.prog.fase = vue.fase+1;
                        vue.fase = vue.prog.fase;
                    }else{
                        vue.prog.fase = vue.fase-1;
                        vue.fase = vue.prog.fase;
                    }
                    vue.$emit("exito", vue.prog.id, vue.prog.fase);
                    window.console.log('ACTUAL::',vue.prog);
                })
                .catch((e) => {
                    window.console.error(e);
                    vue.$refs.alertar.reset();
                    vue.activo = true;
                });
        },
        async mensajito(){
            let texto = 'Al subir de fase (inscripciones -> en desarrollo), no podra volver a la fase inscripciones, debe solicitar al academico nacional';
            let message = {
                title: 'AVISO',
                body: texto,
            };
            let dialogo = await this.$dialog.confirm(message).then((dialog) => dialog).catch(() => {});
            if (!dialogo) return; 
            this.setfase(true,true);
        },
    },
};
</script>
